package tta.destinigo.talktoastro.feature_profile.component

import tta.destinigo.talktoastro.feature_profile.edit_profile.data.EditProfileRequest

sealed class EditProfileEvent {
    data object OnBackKeyPress: EditProfileEvent()
    data class OnSaveProfileButtonClick(val data: EditProfileRequest): EditProfileEvent()
}